var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_7036)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65528 0.473143C6.3354 1.14794 4.27296 2.50672 2.73739 4.37198C1.20181 6.23725 0.264483 8.52227 0.0478516 10.9286H5.53357C5.85158 7.26695 6.91323 3.70869 8.65357 0.471429L8.65528 0.473143ZM5.53357 13.0714H0.0478516C0.26403 15.4778 1.20095 17.7631 2.73623 19.6286C4.27151 21.4942 6.33375 22.8534 8.65357 23.5286C6.91323 20.2913 5.85158 16.7331 5.53357 13.0714ZM11.4033 23.9863C9.3235 20.6905 8.04911 16.9513 7.68328 13.0714H16.3147C15.9489 16.9513 14.6745 20.6905 12.5947 23.9863C12.1978 24.0056 11.8002 24.0056 11.4033 23.9863ZM15.3461 23.5269C17.6657 22.8518 19.7278 21.4929 21.263 19.6276C22.7983 17.7624 23.7353 15.4775 23.9519 13.0714H18.4661C18.1481 16.7331 17.0865 20.2913 15.3461 23.5286V23.5269ZM18.4661 10.9286H23.9519C23.7357 8.52218 22.7987 6.23694 21.2635 4.37136C19.7282 2.50579 17.666 1.14663 15.3461 0.471429C17.0865 3.70867 18.1482 7.26694 18.4661 10.9286ZM11.4033 0.0137149C11.8008 -0.00574655 12.1989 -0.00574655 12.5964 0.0137149C14.6756 3.30962 15.9494 7.04882 16.3147 10.9286H7.68499C8.05699 7.02514 9.33414 3.28286 11.4033 0.0137149Z",
    fill: "#262F71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_7036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteicon);
export default __webpack_public_path__ + "static/media/websiteicon.e8f181f4c02ba9ccea309c8eb2151571.svg";
export { ForwardRef as ReactComponent };